import React, { Component } from 'react';
import { HashLink as Link } from 'react-router-hash-link';

import renderHTML from 'react-render-html';
import PropTypes from 'prop-types';

const parsingRules = {
  St: [
    /St. /g, 'STPLACEHOLDER', 'St. ',
  ],
  US: [
    /U\.S\./g, 'USPLACEHOLDER', 'U.S.',
  ],
};

const applyRules = (text) => {
  let parsedText = text;
  Object.values(parsingRules).forEach((rule) => {
    parsedText = parsedText.replace(new RegExp(rule[0]), rule[1]);
  });
  return parsedText;
};

const revertRules = (text) => {
  let parsedText = text;
  Object.values(parsingRules).forEach((rule) => {
    parsedText = parsedText.replace(new RegExp(rule[1], 'g'), rule[2]);
  });
  return parsedText;
};

const parseText = (text, query) => {
  const parsedQuery = query.trim();
  let parsedText = text.replace(/<[^>]+>/g, "").replace(/(<([^>]+)>)/ig, "");
  parsedText = renderHTML(parsedText).replace(/<\s*iframe[^>]*>(.*?)<\s*\/\s*iframe>/g, ' [Spotify] ');
  parsedText = applyRules(parsedText);

  const lines = parsedText.split('.');
  const output = [];
  lines.forEach((line) => {
    const newLine = revertRules(line);
    output.push(`${newLine.trim()}.`);
  });
  console.log(output);

  let result = '';
  for (let i = 0; i < output.length; i += 1) {
    if (output[i].toLowerCase().includes(parsedQuery.trim().toLowerCase())) {
      const spanText = (parsedQuery[0] === parsedQuery[0].toUpperCase()
        ? `${parsedQuery[0]}${parsedQuery.toLowerCase().slice(1)}`
        : parsedQuery.toLowerCase());
      output[i] = output[i].replace(new RegExp(parsedQuery, 'gi'), `<span style="background-color: yellow">${spanText}</span>`);
      result = output[i];
    }
  }
  result = result.replace(/fi<span/g, '');
  result = result.replace(/jpg" \/>/g, '');
  result = result.replace(/(\b\w*<inline>\w*<\/inline>\w*\b|\b\w*<\/inline>\w*<inline>\w*\b|\b\w*<\/inline>\w*\b|\b\w*<inline>\w*\b)/gi, "");
  result = result.replace(/inline>/g, '');
  result = result.replace(/.jpg" \/>/g, '');
  result = result.replace(/.mp4" \/>/g, '');
  result = result.replace(/>" \/>/g, '');
  console.log(result);
  let parser = new DOMParser();
  let parsedString = parser.parseFromString(result, 'text/html');
  let withoutTags = parsedString.body.textContent;

  return withoutTags;
};

export default class Result extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  render() {
    const {
      title,
      image,
      text,
      query,
      url,
    } = this.props;

    const { loading } = this.state;

    const parsedText = parseText(text, query);
    const valid = (image.length > 'https://static.yourworldapps.nl/apptool/'.length);

    return (
      <Link to={url} >
        <div className="search__result--item">
          <div className="search__result--header">
            {valid &&
            <img
              style={{ opacity: loading ? 0 : 1 }}
              src={image}
              alt={image}
              onLoad={() => {
                this.setState({ loading: false });
              }}
            />}
            <h4 dangerouslySetInnerHTML={{ __html: title }} />
          </div>
          <p>{`${renderHTML(text.slice(0, text.indexOf(".")))}.`}</p>
        </div>
      </Link>
    );
  }
}


Result.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
  text: PropTypes.string.isRequired,
  query: PropTypes.string.isRequired,
  url: PropTypes.string,
};

Result.defaultProps = {
  image: '',
  url: '',
};
